import { render, staticRenderFns } from "./createAuto_2.vue?vue&type=template&id=ffef7828&scoped=true"
import script from "./createAuto_2.vue?vue&type=script&lang=js"
export * from "./createAuto_2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffef7828",
  null
  
)

export default component.exports